<template>
    <box-dropdown>
        <template slot="selected-item">
            <div class="selected-item">
                {{ selectedItem.name }}
            </div>
        </template>
        <template slot="dropdown" slot-scope="{closeDropdown}">
            <perfect-scrollbar-container>
                <div class="dropdown">
                    <div class="item-list">
                        <div class="item" v-for="(addOnCategory, index) in addOnCategories" @click="closeDropdown();itemOnClick(index);">
                            {{ addOnCategory.name }}
                        </div>
                    </div>
                </div>
            </perfect-scrollbar-container>
        </template>
    </box-dropdown>
</template>

<script>
    import PerfectScrollbarContainer from '../PerfectScrollbarContainer';
    import BoxDropdown from '../BoxDropdown';

    export default {
        props: [
            'currentAddOnCategoryIndex',
            'addOnCategories',
        ],
        components: {
            BoxDropdown,
            PerfectScrollbarContainer
        },
        computed: {
            selectedItem() {
                return this.addOnCategories[this.currentAddOnCategoryIndex];
            }
        },
        methods: {
            itemOnClick(index) {
                this.$emit('update:current-add-on-category-index', index);
            }
        },
    }
</script>

<style lang="stylus" type="text/stylus" scoped>
    .selected-item
        width: 100%
        padding: 5px 10px
    .dropdown
        width: 100%
        max-height: 300px;
    .item-list
        padding: 0 30px 0 10px
    .item
        display: block
        padding: 10px 5px
        cursor: pointer
        &:hover
            background-color: rgba(0, 0, 0, 0.1)
</style>